module.exports = __webpack_public_path__ + "img/img_main_txt01.c63d2bf0.svg";